// extracted by mini-css-extract-plugin
export var component = "TermList-module--component--8NQSk";
export var taxonomy = "TermList-module--taxonomy--cE7GU";